'use client';

import Confirmation from '@/components/_rebrand/RequestDemo/Confirmation';
import QualifiedSchedulerStep from '@/components/_rebrand/RequestDemo/QualifiedSchedulerStep';
import { DemoFormSteps, useRequestDemoForm } from '@/components/_rebrand/RequestDemo/RequestDemo.hooks';
import DemoFormStepOne from '@/components/_rebrand/RequestDemo/RequestDemoFormStepOne';
import RequestDemoFormStepTwo from '@/components/_rebrand/RequestDemo/RequestDemoFormStepTwo';
import { Text } from '@/components/_rebrand/Text';
import { TextCombination } from '@/components/_rebrand/TextCombination';
import { HubspotFieldNames } from '@/constants/hubspot';
import { FC } from 'react';

type RequestDemoFormStepsProps = {
  onClose: () => void;
}

const RequestDemoFormSteps: FC<RequestDemoFormStepsProps> = ({ onClose }) => {
  const {
    currentStep,
    demoStepTwoFormData,
    meetingOffered,
    stepOneFormik,
    stepTwoFormik,
    howDidYouHearAboutUsFormik,
    gdprOptIn,
    reOpenQualifiedScheduler,
  } = useRequestDemoForm();

  return (
    <>
      {currentStep === DemoFormSteps.FormStepOne && (
        <>
          <TextCombination type="h3p2"
            align="left"
            headingLevel="h3"
            title="Get a personalized demo"
            description="Help us tailor the demo experience to your needs." />
          <DemoFormStepOne
            formik={stepOneFormik}
            gdprOptIn={gdprOptIn}
          />
        </>
      )}
      {currentStep === DemoFormSteps.FormStepTwo && (
        <>
          <TextCombination type="h3p2"
            align="left"
            title="Tell us a little more about yourself"
            description="So we can show you how Front can address your business needs." />
          <Text type="caption2" className="text-red-500 mt-xs">Note: Your request is not complete until you submit this form.</Text>
          <RequestDemoFormStepTwo
            formik={stepTwoFormik}
          />
        </>
      )}
      {currentStep === DemoFormSteps.Scheduler && demoStepTwoFormData && (
        <QualifiedSchedulerStep
          reOpenQualifiedScheduler={reOpenQualifiedScheduler}
        />
      )}
      {(currentStep === DemoFormSteps.Confirmation || currentStep === DemoFormSteps.ConfirmationSubmitted) && demoStepTwoFormData && (
        <Confirmation
          currentStep={currentStep}
          formik={howDidYouHearAboutUsFormik}
          userFirstName={demoStepTwoFormData?.[HubspotFieldNames.FirstName]}
          onClose={onClose}
          meetingOffered={meetingOffered} />
      )}
    </>
  );
};

export default RequestDemoFormSteps;
